<template>
  <div class="pageFooter">
    <div class="inner">
      <div class="pageFooter_top">
        <span
          v-for="(i, index) in topArr"
          :key="index"
          @click="topClick(i)"
          class="top_name hover-color"
        >
          {{ i.name }}
        </span>
      <!-- <span class="top_name hover-color" @click="$router.push('/feedback')">意见反馈</span> -->
      </div>
      <div class="pageFooter_center">
        <div class="pageFooter_center_left">
          <h3 class="title">友情链接</h3>
          <div class="link">
            <span
              v-for="(i, index) in linkArr"
              :key="index"
              @click="linkClick(i)"
              class="link_name hover-color"
            >
              {{ i.title }}
            </span>
          </div>
        </div>
        <div class="pageFooter_center_center">
          <h3 class="title">合作伙伴</h3>
          <div class="link">
            <span
              v-for="(i, index) in companArr"
              :key="index"
              @click="linkClick(i)"
              class="link_name hover-color"
            >
              {{ i.title }}
            </span>
          </div>
        </div>
        <div class="pageFooter_center_right">
          <div v-for="(i, index) in codeArr" :key="index" class="code">
            <img :src="i.codeurl" :alt="i.name" class="code_img" />
            {{ i.name }}
          </div>
        </div>
      </div>
      <div class="pageFooter_btm">
        <p>©2012-2023  陕西众联健康科技有限责任公司  All Rights Reserved. </p>
        <p>
          <a
            href="https://beian.miit.gov.cn/"
            target="_blank"
            class="hover-color"
          >
            {{ recordNumber }}
          </a>
        </p>
      </div>
    </div>
  </div>
</template>

<script>


export default {
  name: "pageFooter",
  components: {},
  data() {
    return {
      recordNumber: "",
      topArr: [
        {
          name: "关于我们",
          id:'1',
          url: "/footerType",
        },
        {
          name: "免责条款",
          id:'2',
          url: "/footerType",
        },
        {
          name: "版权说明",
          id:'3',
          url: "/footerType",
        },
        {
          name: "商务合作",
          id:'4',
          url: "/footerType",
        },
        {
          name: "意见反馈",
          url: "/feedback",
        },
      ],
      linkArr: [],
      companArr: [],
      codeArr: [
        {
          name: "手机网页版",
          codeurl: require("@/assets/logo1.png"),
        },
        {
          name: "手机网页版",
          codeurl: require("@/assets/logo1.png"),
        },
        {
          name: "微信小程序",
          codeurl: require("@/assets/logo1.png"),
        },
      ],
    };
  },
  methods: {
    topClick(item) {
      console.log(item,'item---')
      const id = item.id;
      this.$router.push({
        path: item.url,
        query: {
          id: id,
          name: item.name
        },
      });
    },
    linkClick(item) {
      // 检查链接是否以http开头
      if (!item.linkUrl.startsWith("http")) {
        item.linkUrl = "http://" + item.linkUrl;
      } else {
        window.open(item.linkUrl, "_blank");
      }
    },
    getFooterTypeInfo() {
      this.$store
       .dispatch("callInterface", {
          url: "/officialweb/useract/getWebsiteInfo",
          method: "get",
        })
       .then((res) => {
        const {officialAccountImg, smallProgramImg, websiteImg, recordNumber} = res.data;
        this.recordNumber = recordNumber;
        this.codeArr = [
          {
            name: "手机网页版",
            codeurl: websiteImg,
          },
          {
            name: "微信公众号",
            codeurl: officialAccountImg,
          },
          {
            name: "微信小程序",
            codeurl: smallProgramImg,
          },
        ];
       })
    },
    getFooterModelInfo() {
      this.$store
        .dispatch("callInterface", {
          url: "/officialweb/useract/getModelType",
          method: "get",
        })
        .then((res) => {
          if (res.code === 200) {
            console.log(res,'res--')
          //  this.topArr = res.data; 
          }      
        }) 
    }
  },
  created() {
    //获取底部网站图片
    this.getFooterTypeInfo();
    // 获取底部模块
    this.getFooterModelInfo();
    this.$store
      .dispatch("callInterface", {
        url: "/officialweb/useract/getFooterTypeInfo",
        method: "get",
      })
      .then((res) => {
        if (res.code === 200) {
          // 根据footerTypeId分类处理数据
          const link1 = res.data.find((item) => item.title === "友情链接");
          const link2 = res.data.find((item) => item.title === "合作伙伴");
          this.linkArr = link1.footerInfoList;
          this.companArr = link2.footerInfoList;
        }
      });
  },
};
</script>

<style lang="scss" scoped>
.pageFooter {
  height: 434px;
  background: #f5f6f9;
  margin-top: -20px;
  box-shadow: 0px -1px 0px 0px rgba(0, 0, 0, 0.12);
  .inner {
    width: 100vw;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .pageFooter_top {
    height: 72px;
    background: #f0f5f9;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 14px;
    color: #3d3d3d;
    line-height: 72px;
    text-align: center;
    width: 100vw;

    .top_name {
      margin-right: 34px;
    }
  }

  .pageFooter_center {
    display: flex;
    padding: 32px 0%;
    justify-content: space-between;
    width: 1200px;
    .pageFooter_center_left,
    .pageFooter_center_center {
      width: 315px;
      position: relative;
      &::after {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 1px;
        height: 100%;
        background-color: #e4e4e5;
      }
      .title {
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 700;
        font-size: 14px;
        color: #26293d;
        line-height: 18px;
        margin-bottom: 22px;
      }

      .link {
        display: flex;
        flex-wrap: wrap;

        .link_name {
          font-family: Microsoft YaHei, Microsoft YaHei;
          font-weight: 400;
          font-size: 12px;
          color: #747681;
          line-height: 18px;
          margin-right: 45px;
          margin-bottom: 4px;
        }
      }
    }

    .pageFooter_center_right {
      display: flex;

      .code {
        margin-left: 40px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        font-size: 12px;
        color: #747681;
        line-height: 18px;
        text-align: center;

        .code_img {
          display: block;
          width: 100px;
          height: 100px;
          margin-bottom: 9px;
          background-color: #fff;
        }
      }
    }
  }

  .pageFooter_btm {
    height: 151px;
    margin: 0 0%;
    padding-top: 33px;
    padding-bottom: 66px;
    border-top: 1px solid #e4e4e5;
    font-family: Microsoft YaHei, Microsoft YaHei;
    font-weight: 400;
    font-size: 12px;
    color: #747681;
    line-height: 18px;
    text-align: center;
    width: 1200px;

    p {
      margin-bottom: 16px;
    }

    a {
      color: #747681;
      text-decoration: none;
    }
  }
}
</style>
<style lang="scss" scoped src="./style/h5_pageFooter.scss"></style>
